import { createSlice } from "@reduxjs/toolkit";
import {
  MccRequest,
  TransactionDownloadRequest,
  TransactionRequest,
  adjustTransaction,
  adjustTransactionRequest,
  blockMerchant,
  createNote,
  deletePhoto,
  downloadTransaction,
  getActivity,
  getActivityRequest,
  getAllTransaction,
  listNote,
  mockCardPurchase,
  searchMCC,
  updateGstAmount,
  updateNote
} from "src/network/graphql/transactionService";
import { User } from "src/types/commonTypes";
import { StoreDispatch } from "../store";
import { Wallet } from "../wallets/walletSlice";
import {
  SearchWalletRequest,
  WalletPreferenceRequest,
  changeWalletPreference,
  getWalletDetail,
  searchWallet
} from "src/network/graphql/walletService";
import { SearchUserRequest, getUserById, searchUser } from "src/network/graphql/userService";
import { immediateToast } from "izitoast-react";
import { initialWalletDetail } from "../walletDetail/walletDetailSlice";
import { initialUserDetail } from "../userDetail/userDetailSlice";
import { initialMccList } from "../mcc/mccSlice";
import { EMPTY_STRING } from "src/components/constant/constant";
// import { processFileName, uploadFileToS3 } from "src/utils/utils";

export type Transaction = {
  id: string;
  name: string;
  Processstatus: string;
  data: {
    description: string;
    merchantName: string;
    merchantId: string;
    merchantCategoryCode: string;
    name: string;
    timestamp: string;
    transType: string;
    updated_at: string;
    created_at: string;
    amount: number;
    type: string;
    wallet_id: string;
    side: string;
    ppan: string;
    price_components: { gst: number };
    wallet: {
      created_at: string;
      description: string;
      name: string;
      updated_at: string;
      wallet_type: string;
      balance: number;
      display_id: string;
      wallet_id: string;
      object_type: string;
    };
    card: {
      card_id: string;
      card_type: string;
      holder_name: string;
    };
    user: {
      attributes: {
        first_name: string;
        last_name: string;
      };
      user_id: string;
      email: string;
    };
    source_wallet: {
      name: string;
      object_id: string;
      wallet_id: string;
      description: string;
    };
    destination_wallet: {
      name: string;
    };
    transaction_user: {
      attributes: {
        first_name: string;
        last_name: string;
      };
      email: string;
    };
  };
  activityStatus: string;
  endDate: string;
  startDate: string;
  ownerId: string;
  image: string;
  receipt_available: boolean;
  approval_number: string;
};

const initialTransaction: Transaction[] = [];

export type Note = {
  noteId: string;
  objectId: string;
  message: string;
  updated_at: string;
  created_by: string;
};

const initialNote: Note[] = [];

const initialUsers: User[] = [];

const initialWallets: Wallet[] = [];

type recieptPhoto = {
  data: string;
};

const initialRecieptPhoto: recieptPhoto = {
  data: EMPTY_STRING
};

type uploadRecieptPhoto = {
  data: string;
};

const initialUploadRecieptPhoto: uploadRecieptPhoto = {
  data: EMPTY_STRING
};

type masterList = {
  id: number;
  categoryName: string;
};

const initialMasterList: masterList[] = [];

const transactionSlice = createSlice({
  name: "transactions",
  initialState: {
    transLoading: false,
    userDetailLoading: false,
    mockCardLoading: false,
    userLoading: false,
    walletLoading: false,
    paymentDataLoading: false,
    deletePhotoLoading: false,
    noteLoading: false,
    walletDetailLoading: false,
    addTransactionLoading: false,
    participantWalletLoading: false,
    blockMerchantLoading: false,
    searchMccLoading: false,
    error: null,
    transList: {
      list: initialTransaction,
      total: 0
    },
    userDetail: initialUserDetail,
    users: {
      list: initialUsers,
      total: 0
    },
    walletList: {
      list: initialWallets,
      total: 0
    },
    transDetail: {
      list: initialTransaction,
      total: 0
    },
    transRecieptPhoto: initialRecieptPhoto,
    uploadRecieptPhoto: initialUploadRecieptPhoto,
    mastersList: {
      total: 0,
      list: initialMasterList
    },
    notes: initialNote,
    walletDetail: initialWalletDetail,
    participantWallet: initialWalletDetail,
    mccList: {
      list: initialMccList,
      total: 0
    }
  },
  reducers: {
    fetchTransListStart: (state) => {
      state.transLoading = true;
    },
    fetchTransListSuccess: (state, action) => {
      state.transLoading = false;
      state.transList.list = action.payload?.list ?? [];
      state.transList.total = action.payload?.total ?? 0;
    },
    fetchTransListFail: (state, action) => {
      state.transLoading = false;
      state.transList.list = [];
      state.transList.total = 0;
      state.error = action.payload;
    },
    fetchUserDetailStart: (state) => {
      state.userDetailLoading = true;
    },
    fetchUserDetailSuccess: (state, action) => {
      state.userDetailLoading = false;
      state.userDetail = action.payload ?? initialUserDetail;
    },
    fetchUserDetailFail: (state, action) => {
      state.userDetailLoading = false;
      state.userDetail = initialUserDetail;
      state.error = action.payload;
    },
    setUsers: (state, action) => {
      state.users = {
        list: action.payload,
        total: action.payload?.length || 0
      };
    },
    fetchUsersStart: (state) => {
      state.userLoading = true;
    },
    fetchUsersSuccess: (state, action) => {
      state.userLoading = false;
      state.users.list = action.payload?.list ?? [];
      state.users.total = action.payload?.total ?? 0;
    },
    fetchUsersFail: (state, action) => {
      state.userLoading = false;
      state.users.list = [];
      state.users.total = 0;
      state.error = action.payload;
    },
    fetchWalletsStart: (state) => {
      state.walletLoading = true;
    },
    fetchWalletsSuccess: (state, action) => {
      state.walletLoading = false;
      state.walletList.list = action.payload?.list ?? [];
      state.walletList.total = action.payload?.total ?? 0;
    },
    fetchWalletsFail: (state, action) => {
      state.walletLoading = false;
      state.walletList.list = [];
      state.walletList.total = 0;
      state.error = action.payload;
    },
    setWallets: (state, action) => {
      state.walletList = {
        list: action.payload,
        total: action.payload?.length || 0
      };
    },
    downloadTransactionStart: (state) => {
      state.paymentDataLoading = true;
    },
    downloadTransactionSuccess: (state) => {
      state.paymentDataLoading = false;
    },
    downloadTransactionFail: (state, action) => {
      state.paymentDataLoading = false;
      state.error = action.payload;
    },
    mockCardStart: (state) => {
      state.mockCardLoading = true;
      state.error = null;
    },
    mockCardSuccess: (state) => {
      state.mockCardLoading = false;
    },
    mockCardFail: (state, action) => {
      state.mockCardLoading = false;
      state.error = action?.payload;
    },
    getNoteStart: (state) => {
      state.noteLoading = true;
    },
    getNoteSuccess: (state, action) => {
      state.noteLoading = false;
      state.notes = action.payload;
    },
    getNoteFail: (state, action) => {
      state.noteLoading = false;
      state.error = action.payload;
    },
    changeNoteStart: (state) => {
      state.noteLoading = true;
    },
    changeNoteSuccess: (state) => {
      state.noteLoading = false;
    },
    changeNoteFail: (state, action) => {
      state.noteLoading = false;
      state.error = action.payload;
    },
    deletePhotoStart: (state) => {
      state.deletePhotoLoading = true;
    },
    deletePhotoSuccess: (state) => {
      state.deletePhotoLoading = false;
    },
    deletePhotoFail: (state, action) => {
      state.deletePhotoLoading = false;
      state.error = action.payload;
    },
    fetchWalletDetailStart: (state) => {
      state.walletDetailLoading = true;
    },
    fetchWalletDetailSuccess: (state, action) => {
      state.walletDetailLoading = false;
      state.walletDetail.wallet = action.payload.wallet ?? initialWalletDetail.wallet;
    },
    fetchWalletDetailFail: (state, action) => {
      state.walletDetailLoading = false;
      state.walletDetail = initialWalletDetail;
      state.error = action.payload;
    },
    updateGstAmountStart: (state) => {
      state.noteLoading = true;
    },
    updateGstAmountSuccess: (state) => {
      state.noteLoading = false;
    },
    updateGstAmountFail: (state, action) => {
      state.noteLoading = false;
      state.error = action.payload;
    },
    setAddTransactionLoading: (state, action) => {
      state.addTransactionLoading = action.payload;
    },
    addTransactionSuccess: (state, action) => {
      state.transDetail.list = action.payload?.list ?? [];
      state.transDetail.total = action.payload?.total ?? 0;
    },
    addTransactionFail: (state, action) => {
      state.transDetail.list = [];
      state.transDetail.total = 0;
      state.error = action.payload;
    },
    getParticipantWalletStart: (state) => {
      state.participantWalletLoading = true;
    },
    getParticipantWalletSuccess: (state, action) => {
      state.participantWalletLoading = false;
      state.participantWallet = action.payload;
    },
    getParticipantWalletFail: (state, action) => {
      state.participantWalletLoading = false;
      state.error = action.payload;
    },
    blockMerchantStart: (state) => {
      state.blockMerchantLoading = true;
    },
    blockMerchantSuccess: (state) => {
      state.blockMerchantLoading = false;
    },
    blockMerchantFail: (state, action) => {
      state.blockMerchantLoading = false;
      state.error = action.payload;
    },
    fetchMccStart: (state) => {
      state.searchMccLoading = true;
      state.error = null;
    },
    fetchMccSuccess: (state, action) => {
      state.searchMccLoading = false;
      state.error = null;
      state.mccList = action?.payload;
    },
    fetchMccFail: (state, action) => {
      state.searchMccLoading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchTransListStart,
  fetchTransListSuccess,
  fetchTransListFail,
  downloadTransactionStart,
  downloadTransactionSuccess,
  downloadTransactionFail,
  fetchWalletsStart,
  fetchWalletsSuccess,
  fetchWalletsFail,
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFail,
  mockCardStart,
  mockCardSuccess,
  mockCardFail,
  getNoteStart,
  getNoteSuccess,
  getNoteFail,
  changeNoteStart,
  changeNoteSuccess,
  changeNoteFail,
  deletePhotoStart,
  deletePhotoSuccess,
  deletePhotoFail,
  fetchWalletDetailStart,
  fetchWalletDetailSuccess,
  fetchWalletDetailFail,
  fetchUserDetailStart,
  fetchUserDetailSuccess,
  fetchUserDetailFail,
  updateGstAmountStart,
  updateGstAmountSuccess,
  updateGstAmountFail,
  setAddTransactionLoading,
  addTransactionSuccess,
  addTransactionFail,
  getParticipantWalletStart,
  getParticipantWalletSuccess,
  getParticipantWalletFail,
  blockMerchantStart,
  blockMerchantSuccess,
  blockMerchantFail,
  fetchMccStart,
  fetchMccSuccess,
  fetchMccFail
} = transactionSlice.actions;

export const { setUsers, setWallets } = transactionSlice.actions;

export const fetchTransListAction = (data: TransactionRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchTransListStart());
    try {
      const response = await getAllTransaction(data);
      const structuredResponse = response.data.search_activity.activity_listing.map((data: any) => ({
        id: data.activity_id,
        name: data.activity_name,
        endDate: data.end_timestamp,
        startDate: data.created_at,
        ownerId: data.owner_id,
        activityStatus: data.activity_status,
        receipt_available: data.receipt_available,
        approval_number: data.approval_number,
        data: JSON.parse(data?.data)
      }));

      dispatch(
        fetchTransListSuccess({
          list: structuredResponse,
          total: response.data.search_activity.total_size
        })
      );
      return response;
    } catch (err) {
      dispatch(fetchTransListFail(err));
    }
  };
};
export const fetchTransDataAction = (data: getActivityRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchTransListStart());
    try {
      const response = await getActivity(data);
      const structuredResponse = response.data.get_activity;
      const formattedResponse = {
        id: structuredResponse.activity_id,
        name: structuredResponse.activity_name,
        endDate: structuredResponse.end_timestamp,
        startDate: structuredResponse.created_at,
        ownerId: structuredResponse.owner_id,
        activityStatus: structuredResponse.activity_status,
        receipt_available: structuredResponse.receipt_available,
        approval_number: structuredResponse.approval_number,
        data: JSON.parse(structuredResponse?.data)
      };

      dispatch(
        fetchTransListSuccess({
          list: [formattedResponse],
          total: 1
        })
      );
      return response;
    } catch (err) {
      dispatch(fetchTransListFail(err));
    }
  };
};

export const downloadTransactionAction = (data: TransactionDownloadRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(downloadTransactionStart());
    try {
      const response = await downloadTransaction(data);
      const downloadUrl = response.data.download_transactions.download_url;

      if (downloadUrl) {
        window.open(downloadUrl, "_blank");
      }

      if (!response.data.download_transactions.count || response.data.download_transactions.count === 0) {
        immediateToast("error", {
          message: "No Transaction Found",
          timeout: 3000,
          position: "topCenter"
        });
      }
      dispatch(downloadTransactionSuccess());
    } catch (err) {
      dispatch(downloadTransactionFail(err));
    }
  };
};

export const fetchUserListAction = (data: SearchUserRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchUsersStart());
    try {
      const response = await searchUser({
        user_filter: data.user_filter,
        size: data.size,
        from: data.from
      });

      const structuredResponse = response.data.search_user.user_listing.map((user: any) => ({
        id: user.user_id,
        firstName: user.attributes.first_name,
        lastName: user.attributes.last_name,
        email: user.email,
        role: "not available",
        status: user.is_active,
        userId: user.user_id
      }));

      dispatch(
        fetchUsersSuccess({
          list: structuredResponse,
          total: response.data.search_user.total_size
        })
      );
    } catch (error) {
      dispatch(fetchUsersFail(error));
    }
  };
};

export const fetchWalletListAction = (data: SearchWalletRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchWalletsStart());
    try {
      const response = await searchWallet(data);

      const structuredResponse = response.data.search_wallet.items.map((wallet: any) => ({
        id: wallet.wallet_id,
        displayId: wallet.display_id,
        description: wallet.description,
        balance: wallet.balance,
        status: wallet.wallet_status,
        name: wallet.name,
        participant: {
          role: "PARTICIPANT",
          fullName: `${wallet.user?.attributes?.first_name ?? "-"} ${wallet.user?.attributes?.last_name ?? "-"}`,
          email: wallet?.user?.email
        }
      }));

      dispatch(
        fetchWalletsSuccess({
          list: structuredResponse,
          total: response.data.search_wallet.total_size
        })
      );
    } catch (error) {
      dispatch(fetchWalletsFail(error));
    }
  };
};

export const mockPurchaseAction = (cardId: string, amount: number, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(mockCardStart());
    try {
      const response = await mockCardPurchase(cardId, amount);

      immediateToast("success", {
        message: "Mock purchase successfully",
        timeout: 3000,
        position: "topCenter"
      });
      dispatch(mockCardSuccess());
      if (cb) cb();
      return response;
    } catch (err) {
      dispatch(mockCardFail(err));
    }
  };
};

export const getNoteAction = (transactionId: string) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(getNoteStart());
    try {
      const response = await listNote(transactionId);
      const structuredResponse = response.data.list_notes.note.map((data: any) => ({
        noteId: data.note_id,
        message: data.payload.message,
        updated_at: data.updated_at,
        created_by: data.created_by
      }));

      dispatch(getNoteSuccess(structuredResponse));
    } catch (err) {
      dispatch(getNoteFail(err));
    }
  };
};

export const createNoteAction = (transactionId: string, note: string, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(changeNoteStart());
    try {
      await createNote(transactionId, note);
      dispatch(changeNoteSuccess());
      if (cb) cb();
    } catch (err) {
      dispatch(changeNoteFail(err));
    }
  };
};

export const updateNoteAction = (noteId: string, note: string, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(changeNoteStart());
    try {
      await updateNote(noteId, note);
      dispatch(changeNoteSuccess());
      if (cb) cb();
    } catch (err) {
      dispatch(changeNoteFail(err));
    }
  };
};

export const deleteFile = (assetId: string, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(deletePhotoStart());
    try {
      await deletePhoto(assetId);

      immediateToast("success", {
        message: "photo successfully deleted.",
        timeout: 3000,
        position: "topCenter"
      });
      dispatch(deletePhotoSuccess());
      if (cb) cb();
    } catch (err) {
      dispatch(deletePhotoFail(err));
    }
  };
};

export const fetchWalletDetailAction = (data: string, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchWalletDetailStart());
    try {
      const walletResponse = await getWalletDetail(data);
      const wallet = walletResponse.data.get_wallet;
      const structuredWalletResponse = {
        name: wallet?.name,
        description: wallet?.description,
        balance: wallet?.balance,
        id: wallet?.wallet_id
      };

      dispatch(
        fetchWalletDetailSuccess({
          wallet: structuredWalletResponse
        })
      );
      if (cb) cb();
    } catch (error) {
      dispatch(fetchWalletDetailFail(error));
    }
  };
};

export const fetchUserDetailAction = (data: string) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchUserDetailStart());
    try {
      const response = await getUserById({ user_id: data });
      const user = response.data.get_user;

      dispatch(
        fetchUserDetailSuccess({
          user: {
            id: user.user_id,
            initial: user.attributes.initial,
            firstName: user.attributes.first_name,
            lastName: user.attributes.last_name,
            email: user.email
          }
        })
      );
    } catch (error) {
      dispatch(fetchUserDetailFail(error));
    }
  };
};

export const updateGstAmountAction = (id: string, amount: number) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(updateGstAmountStart());
    try {
      await updateGstAmount(id, amount);
      dispatch(updateGstAmountSuccess());
    } catch (error) {
      dispatch(updateGstAmountFail(error));
    }
  };
};

export const addTransactionRecord = (data: adjustTransactionRequest, cb?: (_value: boolean) => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(setAddTransactionLoading(true));
    try {
      const response = await adjustTransaction(data);
      const { link_id, owner_id } = response.data.adjust_cash_transaction;

      await new Promise((resolve) => setTimeout(resolve, 3000));

      const activityresponse = await getActivity({ link_id, owner_id });
      const structuredResponse = activityresponse.data.get_activity;

      if (structuredResponse) {
        const formattedResponse = {
          id: structuredResponse.activity_id,
          name: structuredResponse.activity_name,
          endDate: structuredResponse.end_timestamp,
          startDate: structuredResponse.created_at,
          ownerId: structuredResponse.owner_id,
          activityStatus: structuredResponse.activity_status,
          receipt_available: structuredResponse.receipt_available,
          approval_number: structuredResponse.approval_number,
          data: JSON.parse(structuredResponse?.data)
        };

        dispatch(
          addTransactionSuccess({
            list: [formattedResponse],
            total: 1
          })
        );
        dispatch(setAddTransactionLoading(false));
        if (cb) cb(true);
      } else {
        dispatch(setAddTransactionLoading(false));
        if (cb) cb(false);
      }
    } catch (error) {
      dispatch(addTransactionFail(error));
      dispatch(setAddTransactionLoading(false));
    }
  };
};

export const getParticipantWallet = (data: string, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(getParticipantWalletStart());
    try {
      const walletResponse = await getWalletDetail(data);
      const wallet = walletResponse.data.get_wallet;
      const structuredWalletResponse = {
        name: wallet?.name,
        description: wallet?.description,
        balance: wallet?.balance,
        id: wallet?.wallet_id,
        displayId: wallet?.display_id,
        participant: {
          id: wallet?.user?.user_id,
          fullName: `${wallet?.user?.attributes?.first_name ?? "-"} ${wallet?.user?.attributes?.last_name ?? "-"}`,
          email: wallet?.user?.email
        },
        preferences: {
          cashWithdrawalAllowed: wallet?.preferences?.is_cash_withdrawal_allowed,
          maxAllowedLimit: wallet?.preferences?.maximum_allowed_limit,
          preferenceId: wallet?.preferences?.preference_id,
          spendFrequency: wallet?.preferences?.spend_frequency,
          spendLimit: wallet?.preferences?.spend_limit,
          blockedMerchants: wallet?.preferences?.blocked_merchant_ids,
          blockedMccCategories: wallet?.preferences?.blocked_mcc_categories
        }
      };

      dispatch(
        getParticipantWalletSuccess({
          wallet: structuredWalletResponse
        })
      );
      if (cb) cb();
    } catch (error) {
      dispatch(getParticipantWalletFail(error));
    }
  };
};

export const blockMerchantAction = (data: { wallet_ids: string[]; merchant_id: string }, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(blockMerchantStart());
    try {
      await blockMerchant(data);
      dispatch(blockMerchantSuccess());
      immediateToast("success", {
        message: "Merchant blocked successfully",
        timeout: 3000,
        position: "topCenter"
      });
      if (cb) cb();
    } catch (error) {
      dispatch(blockMerchantFail(error));
    }
  };
};

export const changePreferenceAction = (data: WalletPreferenceRequest, cb?: () => void) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(blockMerchantStart());
    try {
      await changeWalletPreference(data);
      dispatch(blockMerchantSuccess());
      immediateToast("success", {
        message: "Merchant unblocked successfully",
        timeout: 3000,
        position: "topCenter"
      });
      if (cb) cb();
    } catch (err) {
      dispatch(blockMerchantFail(err));
    }
  };
};

export const searchMccAction = (filter: MccRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchMccStart());
    try {
      const response = await searchMCC(filter);

      dispatch(
        fetchMccSuccess({
          list: response.data?.search_mcc?.items,
          total: response?.data?.search_mcc?.total_size
        })
      );
    } catch (err) {
      dispatch(fetchMccFail(err));
    }
  };
};

export default transactionSlice.reducer;
